import React, {Component} from 'react';
import '../../asset/css/login.css';
import PageContentWallpaper from '../common/ef-pageContent';
import AddingModel from '../common/adding-model';

export default class ComSettingProject extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }
        this.MyModel = [
            {
                field: "name",
                desc: "Name",
                placeholder: "name",
                required: true,
                type: "text",
                readonly: false,
                staticValue:""
            },
            {
                field: "description",
                desc: "Description",
                placeholder: "Description",
                required: true,
                type: "text",
                readonly: false,
                staticValue:""
            },

        ];
        /*
        {field:"department",desc:"Department",placeholder:"Department",required:true,type:"text",readonly:false,
                filter:true,filterTable:"department",filterKey:"name",filterValue:"description"},
         */
        this.ModelName = "project";
        this.Crum = "/crum";
        this.PrimaryKey = "org"
    }

    /*



	NumberFailed float,
	NumberSuccess float,
     */



    render() {
        return (


            <PageContentWallpaper {...this.props} >

                <div className="row">
                    <div className="col-xs-12">
                        <h2>Create Project</h2>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12">
                        <AddingModel
                            MyModel={this.MyModel}
                            ModelName={this.ModelName}
                            ListDisplayKey={["Name"]}
                            ListDeleteKey={[
                                {field: this.PrimaryKey, type: "string"},
                                {field: "name", type: "string"},
                            ]}
                            Crum={this.Crum}
                            PrimaryKey={this.PrimaryKey}
                        />
                    </div>
                </div>


            </PageContentWallpaper>


        );
    }
}